"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectPlaceholder = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _useTheme = require("../../../../theme/utils/useTheme");
var _selectV2Theme = require("../selectV2Theme");
var _SelectPlaceholderStyled = require("./SelectPlaceholderStyled");
const SelectPlaceholder = _ref => {
  let {
    children,
    hasContentBefore,
    ...rest
  } = _ref;
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  return /*#__PURE__*/_react.default.createElement(_SelectPlaceholderStyled.SelectPlaceholderStyled, (0, _extends2.default)({
    themeMode: themeMode
  }, _selectV2Theme.selectBasicFontTheme.variant[themeMode], {
    lineClamp: 1,
    "aria-hidden": true,
    hasContentBefore: hasContentBefore
  }, rest), children);
};
exports.SelectPlaceholder = SelectPlaceholder;
//# sourceMappingURL=SelectPlaceholder.js.map